/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Content_TaglineInputs */

const en_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The capital city's stand-alone practice facility. Grass tees, short game areas, and year-round instruction under one roof.`)
};

const es_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El centro de práctica independiente de la capital. Puestos de césped natural, zonas de juego corto e instrucción todo el año en un solo lugar.`)
};

const de_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die eigenständige Übungsanlage der Hauptstadt. Rasenabschläge, Kurzspielbereiche und ganzjähriger Unterricht an einem Ort.`)
};

const zh_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`州府的独立练习场。天然草皮打位、短杆区以及全年教学，一站式满足。`)
};

const ar_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منشأة التدريب المستقلة في العاصمة. منصات ضرب عشبية ومناطق للعب القصير وتدريب على مدار العام في مكان واحد.`)
};

const fr_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le centre d'entraînement indépendant de la capitale. Postes sur gazon, zones de petit jeu et cours toute l'année, réunis en un seul lieu.`)
};

const vi_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cơ sở tập luyện độc lập của thủ phủ. Ô phát bóng trên cỏ, khu tập lối chơi ngắn và hướng dẫn quanh năm, tất cả ở cùng một nơi.`)
};

const sw_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kituo huru cha mazoezi katika mji mkuu. Sehemu za kupigia mpira kwenye nyasi, maeneo ya mchezo mfupi na mafunzo mwaka mzima mahali pamoja.`)
};

const th_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ศูนย์ฝึกซ้อมแบบสแตนด์อโลนแห่งเมืองหลวง จุดตีบนหญ้า พื้นที่ฝึกลูกสั้น และการสอนตลอดทั้งปีในที่เดียว`)
};

const bs_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samostalni trening centar u glavnom gradu. Mjesta za udarce na travi, zone za kratku igru i obuka tokom cijele godine na jednom mjestu.`)
};

const ja_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`州都にある独立型の練習施設。天然芝打席、ショートゲームエリア、通年のレッスンがひとつの場所にそろっています。`)
};

const ko_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주도에 있는 독립형 연습 시설. 천연 잔디 타석, 숏게임 구역, 연중 레슨을 한곳에서 누릴 수 있습니다.`)
};

const pt_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O centro de treino independente da capital. Baias de grama natural, áreas de jogo curto e aulas o ano todo em um só lugar.`)
};

const it_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il centro di allenamento indipendente della capitale. Postazioni su erba, aree per il gioco corto e lezioni tutto l'anno in un unico posto.`)
};

const sv_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huvudstadens fristående träningsanläggning. Gräsutslagsplatser, områden för närspel och undervisning året runt, samlat på ett ställe.`)
};

const nl_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het zelfstandige oefencentrum van de hoofdstad. Grasafslagplaatsen, korte-spelgebieden en het hele jaar door les, alles op één plek.`)
};

const da_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hovedstadens selvstændige træningsanlæg. Græsudslagssteder, områder til det korte spil og undervisning året rundt samlet ét sted.`)
};

const nb_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hovedstadens frittstående treningsanlegg. Gressutslagsplasser, områder for kortspill og undervisning hele året, samlet på ett sted.`)
};

const fi_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pääkaupungin itsenäinen harjoituskeskus. Lyöntipaikat nurmella, lähipelialueet ja ympärivuotinen opetus samassa paikassa.`)
};

const pl_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samodzielny ośrodek treningowy w stolicy stanu. Stanowiska na trawie, strefy krótkiej gry i nauka przez cały rok w jednym miejscu.`)
};

const ru_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самостоятельный тренировочный центр в столице штата. Площадки с натуральной травой, зоны короткой игры и занятия круглый год в одном месте.`)
};

const tr_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başkentin bağımsız antrenman tesisi. Çim atış noktaları, kısa oyun alanları ve yıl boyu eğitim tek bir yerde.`)
};

const hi_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`राजधानी का स्वतंत्र अभ्यास केंद्र। घास वाले टी, शॉर्ट गेम क्षेत्र और साल भर प्रशिक्षण, सब एक ही जगह।`)
};

const id_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fasilitas latihan mandiri di ibu kota. Tempat pukul di atas rumput, area short game, dan pelatihan sepanjang tahun dalam satu tempat.`)
};

const ms_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemudahan latihan berdiri sendiri di ibu kota. Petak pukulan berumput, kawasan permainan pendek dan latihan sepanjang tahun di satu tempat.`)
};

const cs_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samostatné tréninkové centrum v hlavním městě. Odpaliště na trávě, zóny pro krátkou hru a celoroční výuka na jednom místě.`)
};

const el_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η αυτόνομη εγκατάσταση προπόνησης της πρωτεύουσας. Θέσεις χτυπήματος σε γρασίδι, χώροι για το κοντινό παιχνίδι και διδασκαλία όλο τον χρόνο σε ένα μέρος.`)
};

const he_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מתקן האימון העצמאי של עיר הבירה. עמדות חבטה על דשא, אזורי משחק קצר והדרכה לאורך כל השנה, הכול במקום אחד.`)
};

const af_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die hoofstad se selfstandige oefenfasiliteit. Grasafslaanplekke, kortspelareas en onderrig regdeur die jaar, alles op een plek.`)
};

const hu_range_content_tagline = /** @type {(inputs: Range_Content_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A főváros önálló gyakorlóközpontja. Füves elütőhelyek, rövidjáték-területek és egész éves oktatás egy helyen.`)
};

/**
* | output |
* | --- |
* | "The capital city's stand-alone practice facility. Grass tees, short game areas, and year-round instruction under one roof." |
*
* @param {Range_Content_TaglineInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_content_tagline = /** @type {((inputs?: Range_Content_TaglineInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Content_TaglineInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_content_tagline(inputs)
	if (locale === "de") return de_range_content_tagline(inputs)
	if (locale === "zh") return zh_range_content_tagline(inputs)
	if (locale === "ar") return ar_range_content_tagline(inputs)
	if (locale === "fr") return fr_range_content_tagline(inputs)
	if (locale === "vi") return vi_range_content_tagline(inputs)
	if (locale === "sw") return sw_range_content_tagline(inputs)
	if (locale === "th") return th_range_content_tagline(inputs)
	if (locale === "bs") return bs_range_content_tagline(inputs)
	if (locale === "ja") return ja_range_content_tagline(inputs)
	if (locale === "ko") return ko_range_content_tagline(inputs)
	if (locale === "pt") return pt_range_content_tagline(inputs)
	if (locale === "it") return it_range_content_tagline(inputs)
	if (locale === "sv") return sv_range_content_tagline(inputs)
	if (locale === "nl") return nl_range_content_tagline(inputs)
	if (locale === "da") return da_range_content_tagline(inputs)
	if (locale === "nb") return nb_range_content_tagline(inputs)
	if (locale === "fi") return fi_range_content_tagline(inputs)
	if (locale === "pl") return pl_range_content_tagline(inputs)
	if (locale === "ru") return ru_range_content_tagline(inputs)
	if (locale === "tr") return tr_range_content_tagline(inputs)
	if (locale === "hi") return hi_range_content_tagline(inputs)
	if (locale === "id") return id_range_content_tagline(inputs)
	if (locale === "ms") return ms_range_content_tagline(inputs)
	if (locale === "cs") return cs_range_content_tagline(inputs)
	if (locale === "el") return el_range_content_tagline(inputs)
	if (locale === "he") return he_range_content_tagline(inputs)
	if (locale === "af") return af_range_content_tagline(inputs)
	if (locale === "hu") return hu_range_content_tagline(inputs)
	return en_range_content_tagline(inputs)
});